// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"228996f4","703":"dba0e22e","787":"419723f6"}[chunkId] + ".chunk.js";
};